import {
  eventsListByOrganizationSlug,
  getEvents,
  getOrganizationsEvents
} from "./chunk-OVZ7EZQN.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/hooks/wbk/events/listing.ts
import {
  useInfiniteQuery,
  useQuery
} from "@tanstack/react-query";
var useEventsList = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["eventsList", props],
    queryFn: () => getEvents(props)
  }, options));
};
var usePaginatedEventsList = (props, options) => {
  return useInfiniteQuery(__spreadValues({
    queryKey: ["eventsPaginatedList", props],
    queryFn: (_0) => __async(null, [_0], function* ({ pageParam = 1 }) {
      const response = yield getEvents(__spreadProps(__spreadValues({}, props), { perPage: props.perPage || 10, page: pageParam }));
      return response;
    }),
    getNextPageParam: ({ per_page, total }, __, page) => {
      const current = page || 1;
      const totalPages = Math.ceil(total / per_page);
      return current < totalPages ? current + 1 : void 0;
    },
    initialPageParam: 1,
    select: (data) => {
      var _a, _b;
      const events = data.pages.flatMap((page) => page.events);
      const seasons = (_b = (_a = data.pages[0]) == null ? void 0 : _a.seasons) != null ? _b : [];
      return {
        events,
        seasons
      };
    }
  }, options));
};
var useEventsListByOrganizationSlug = (props) => {
  return useQuery({
    queryKey: ["eventsListByOrganizationSlug", props],
    queryFn: () => eventsListByOrganizationSlug(props)
  });
};
var useOrganizationsEvents = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["organizationsEvents", props],
    queryFn: () => getOrganizationsEvents(props)
  }, options));
};

export {
  useEventsList,
  usePaginatedEventsList,
  useEventsListByOrganizationSlug,
  useOrganizationsEvents
};
//# sourceMappingURL=chunk-RH6CIZNU.mjs.map